import { useOutletContext } from "react-router";

import CuteBanner from "../shopping/component/themes/cute/banner";
import ModernBanner from "../shopping/component/themes/modern/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import SearchForm from "./component/searchForm";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import { Container } from "../common/styled";

const Search = () => {
  const { theme } = useOutletContext();

  const banners = {
    // 0: ModernBanner,
    // 1: ChicBanner,
    // 2: ModernBanner,
    // 3: CuteBanner,
    4: SimpleBanner,
  };

  const renderComponent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner && <Banner />}
        <SearchForm />
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderComponent()}</Container>;
};

export default Search;
